import React from "react";

import { connect } from "react-redux";
import RatingSlide from "./RatingSlide";
import MultipleChoices from "./MultipleChoices";
import FreeAnswerSlide from "./FreeAnswerSlide";

const Slides = ({
  questionType,
  value,
  onValueChange,
  onPressChoice,
  leftLabel,
  rightLabel,
  image,
  title,
  choices,
  options,
  scale = [1, 10],
}) => {
  if (questionType === "RATING") {
    return (
      <RatingSlide
        onValueChange={onValueChange}
        value={value}
        leftLabel={leftLabel}
        rightLabel={rightLabel}
        image={image}
        title={title}
        scale={scale}
      />
    );
  }

  if (questionType === "FREE_ANSWER") {
    return (
      <FreeAnswerSlide
        onValueChange={onValueChange}
        value={value}
        title={title}
      />
    );
  }

  return (
    <MultipleChoices
      onPressChoice={onPressChoice}
      title={title}
      choices={choices}
      options={options}
    />
  );
};

const mapStateToProps = state => {
  const { language } = state.profileSettings;
  return {
    language,
  };
};

export default connect(mapStateToProps, {})(Slides);
